import { render, staticRenderFns } from "./CartOrderItem.vue?vue&type=template&id=060e6292"
import script from "./CartOrderItem.vue?vue&type=script&lang=js"
export * from "./CartOrderItem.vue?vue&type=script&lang=js"
import style0 from "./CartOrderItem.vue?vue&type=style&index=0&id=060e6292&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports